<template>
  <form @submit.prevent>
    <FormGroup label="Tabla" small-label required horizontal horizontal-narrow
      class="margin-bottom-2">
      <Dropdown
        :value="dataSource && dataSource.table_id"
        :show-search="true"
        fixed-items
        @input="cambiarTabla"
      >
        <DropdownSection
          v-for="base in bases"
          :key="base.id"
          :title="base.name"
        >
          <DropdownItem
            v-for="tabla in base.tables"
            :key="tabla.id"
            :name="tabla.name"
            :value="tabla.id"
            :indented="true"
          >
            {{ tabla.name }}
          </DropdownItem>
        </DropdownSection>
      </Dropdown>
    </FormGroup>

    <FormGroup label="Tipo" small-label horizontal horizontal-narrow
      class="margin-bottom-2">
      <Dropdown :value="widget.tipo_grafica" @input="guardar('tipo_grafica', $event)">
        <DropdownItem name="Barras" value="bar"></DropdownItem>
        <DropdownItem name="Lineas" value="line"></DropdownItem>
        <DropdownItem name="Pastel" value="pie"></DropdownItem>
        <DropdownItem name="Dona" value="doughnut"></DropdownItem>
      </Dropdown>
    </FormGroup>

    <FormGroup label="Agrupar por" small-label required horizontal horizontal-narrow
      class="margin-bottom-2">
      <Dropdown
        :value="widget.campo_grupo"
        :disabled="!tableFields.length"
        @input="guardar('campo_grupo', $event)"
      >
        <DropdownItem
          v-for="campo in tableFields"
          :key="campo.id"
          :name="campo.name"
          :value="campo.id"
        ></DropdownItem>
      </Dropdown>
    </FormGroup>

    <FormGroup label="Calcular" small-label horizontal horizontal-narrow
      class="margin-bottom-2">
      <Dropdown :value="widget.agregacion" @input="guardar('agregacion', $event)">
        <DropdownItem name="Cuantas filas" value="count"></DropdownItem>
        <DropdownItem name="Suma" value="sum"></DropdownItem>
        <DropdownItem name="Promedio" value="avg"></DropdownItem>
        <DropdownItem name="Minimo" value="min"></DropdownItem>
        <DropdownItem name="Maximo" value="max"></DropdownItem>
      </Dropdown>
    </FormGroup>

    <FormGroup
      v-if="widget.agregacion && widget.agregacion !== 'count'"
      label="Del campo"
      small-label
      required
      horizontal
      horizontal-narrow
    >
      <Dropdown
        :value="widget.campo_valor"
        :disabled="!camposNumericos.length"
        @input="guardar('campo_valor', $event)"
      >
        <DropdownItem
          v-for="campo in camposNumericos"
          :key="campo.id"
          :name="campo.name"
          :value="campo.id"
        ></DropdownItem>
      </Dropdown>
      <div v-if="!camposNumericos.length" class="extras-mg-grafica__aviso">
        Esta tabla no tiene campos numericos. Con "Cuantas filas" no hace falta.
      </div>
    </FormGroup>
  </form>
</template>

<script>
import tableFields from '@baserow/modules/database/mixins/tableFields'
import { notifyIf } from '@baserow/modules/core/utils/error'

export default {
  name: 'GraficaWidgetSettings',
  mixins: [tableFields],
  props: {
    dashboard: { type: Object, required: true },
    widget: { type: Object, required: true },
    storePrefix: { type: String, required: false, default: '' },
  },
  computed: {
    dataSource() {
      return this.$store.getters[
        `${this.storePrefix}dashboardApplication/getDataSourceById`
      ](this.widget.data_source_id)
    },
    integration() {
      return this.$store.getters[
        `${this.storePrefix}dashboardApplication/getIntegrationById`
      ](this.dataSource?.integration_id)
    },
    bases() {
      return this.integration?.context_data?.databases || []
    },
    /**
     * Los campos que se pueden sumar o promediar.
     *
     * Ademas de los numericos de siempre entran las columnas calculadas cuyo
     * resultado es un numero: formula, y con ella count, rollup y lookup, que
     * son formulas por dentro y traen su tipo en `formula_type`. El widget ya
     * sabia graficarlas —hace parseFloat del valor—, pero no aparecian en este
     * desplegable, asi que un "Ingreso USD" calculado no se podia elegir y
     * habia que duplicar el dato en una columna escrita a mano.
     */
    camposNumericos() {
      const simples = ['number', 'rating', 'autonumber', 'duration']
      return this.tableFields.filter(
        (f) =>
          simples.includes(f.type) ||
          (f.formula_type !== undefined &&
            simples.includes(f.formula_type))
      )
    },
  },
  methods: {
    /* Lo pide el mixin tableFields para saber que campos traer. */
    getTableId() {
      return this.dataSource?.table_id
    },
    async cambiarTabla(idTabla) {
      try {
        await this.$store.dispatch(
          `${this.storePrefix}dashboardApplication/updateDataSource`,
          { dataSourceId: this.dataSource.id, values: { table_id: idTabla } }
        )
        // Los campos de la tabla anterior ya no existen aqui: se limpian para
        // no dejar la grafica apuntando a un campo de otra tabla.
        await this.guardarVarios({ campo_grupo: null, campo_valor: null })
      } catch (e) {
        notifyIf(e, 'dashboard')
      }
    },
    guardar(campo, valor) {
      return this.guardarVarios({ [campo]: valor })
    },
    async guardarVarios(valores) {
      const originales = {}
      for (const k of Object.keys(valores)) {
        originales[k] = this.widget[k]
      }
      try {
        await this.$store.dispatch(
          `${this.storePrefix}dashboardApplication/updateWidget`,
          { widgetId: this.widget.id, values: valores, originalValues: originales }
        )
      } catch (e) {
        notifyIf(e, 'dashboard')
      }
    },
  },
}
</script>
